import { UploadFileSection } from 'app/components/shared/UploadFileSection'
import { BgRetina } from 'app/components/ui/BgRetina'
import { Container } from 'app/components/ui/Container'
import { Image } from 'app/components/ui/Image'
import { Modal } from 'app/components/ui/Modal'
import { Text } from 'app/components/ui/Text'
import { Title } from 'app/components/ui/Title'
import React, { useState } from 'react'
import styled, { useTheme } from 'styled-components'

import { InputHolderDocumentInnerForm } from './InputHolderDocumentInnerForm'

type Props = {
  isUpdate: boolean
}
export const InputHolderDocumentForm = ({ isUpdate }: Props): JSX.Element => {
  const theme = useTheme()

  const [showUploadDocumentHolderModal, setShowUploadDocumentHolderModal] =
    useState(false)

  return isUpdate ? (
    <>
      <FileUploadedContainer>
        <UploadFileSection title={`Documento d'identità del titolare`}>
          <Image
            src='https://res.cloudinary.com/estra/image/upload/v1629356473/estra20dev/sponsor/checkmark.svg'
            alt='success'
            width={34}
          ></Image>
          <Text variant='s16' mt={0.5} color={theme.color.primari.neroEstra}>
            File Caricato
          </Text>
          <EditFileLink onClick={() => setShowUploadDocumentHolderModal(true)}>
            <Text variant='s12' weight='400' color={theme.color.neutri.grigio}>
              MODIFICA
            </Text>
          </EditFileLink>
        </UploadFileSection>
      </FileUploadedContainer>
      {showUploadDocumentHolderModal && (
        <Modal
          onCloseRequest={() => setShowUploadDocumentHolderModal(false)}
          title='Aggiornamento Documento di Identità'
        >
          <InputHolderDocumentInnerForm
            onSuccess={() => setShowUploadDocumentHolderModal(false)}
          ></InputHolderDocumentInnerForm>
        </Modal>
      )}
    </>
  ) : (
    <BgRetina bgImage='https://res.cloudinary.com/estra/image/upload/v1629352138/estra20dev/sponsor/documents_upload/holder_document_upload_bg.svg'>
      <Container>
        <Wrapper>
          <Title size={3} mb={3}>
            Pronto? {'\n'}
            Iniziamo con il caricamento della foto del documento d’identità del
            titolare
          </Title>
          <InputHolderDocumentInnerForm></InputHolderDocumentInnerForm>
        </Wrapper>
      </Container>
    </BgRetina>
  )
}

const FileUploadedContainer = styled(Container)`
  text-align: center;
`

const Wrapper = styled.div`
  text-align: center;

  max-width: 900px;
  margin-right: auto;
  margin-left: auto;
`

const EditFileLink = styled.a`
  cursor: pointer;
`
